module.exports = __webpack_public_path__ + "img/application-pdf.d45a74be.png";